import { useState } from 'react'

import './style.scss';
import { useAppDispatch } from '../../redux/hooks';
import { setShowNewPost } from '../../redux/reducers/userSlice';
import { userStateData } from '../../data/userStateData';
import { postConnector } from '../../server/connector/postConnector';

function AppPost() {

	const dispatch = useAppDispatch()

	const [makingPost, setMakingPost] = useState<boolean>(false) // true during posting to server
	
	const [selectedCommunity, setSelectedCommunity] = useState<string>('')
	// const [postTitle, setPostTitle] = useState<string>('')
	const [postMessage, setPostMessage] = useState<string>('')

	const backButtonClickHandler = () => {
		if (makingPost !== true) {
			dispatch(setShowNewPost(false))
		}
	}

	const communitySelectHandler = (newValue: string) => {
		setSelectedCommunity(newValue)
	}

	const postButtonClickHandler = () => {
		setMakingPost(true)
		if (postConnector.requestInProgress === false) {
			postConnector.performCreatePostRequest(
				userStateData.getId(),
				'',
				postMessage,
				'',
				selectedCommunity !== '' ? `${userStateData.communities.indexOf(selectedCommunity) + 1}` : '1'
			).then((successResponse) => {
				// console.log(`post successResponse = ${successResponse}`)
				setMakingPost(false)
				dispatch(setShowNewPost(false))
			})
		}
		
	}
	
	return (
		<>
			<div className='section-wrap app-new-post-wrap'>
				<div className='app-new-post-header-wrap'>
					<img
						src={'/imgs/icons/instructor/icon-instructor-header-back-button.svg'}
						className='app-new-post-back-button'
						alt='Back Button'
						onClick={() => {
							backButtonClickHandler()
						}}
					/>
					<button
						className='app-new-post-post-button'
						disabled={postMessage.length < 2 || makingPost || selectedCommunity === ''}
						onClick={() => postButtonClickHandler()}
					>Post</button>
				</div>
				<div
					className='app-new-post-community-select-wrap'
				>
					<select
						className='app-new-post-community-select'
						value={selectedCommunity ? selectedCommunity : ''}
						disabled={makingPost}
						onChange={(evt) => {
							communitySelectHandler(evt.target.value)
						}}
					>
						<option value="" disabled>Select a community</option>
						{userStateData.communities.map((valueLabel: string, index: number) => 
							<option 
								value={valueLabel}
								key={`communityOption${index}`}
							>{valueLabel}</option>
						)}
					</select>
					<img
							className='app-new-post-community-select-arrows'
							src='/imgs/icons/posts/icon-new-post-select-arrows.svg'
						/>
					<img
						className='app-new-post-community-select-icon'
						src='/imgs/icons/posts/icon-new-post-logo.svg'
						alt='Community Logo'
					/>
				</div>
				{/* <input 
					className='app-new-post-title-input'
					value={postTitle}
					placeholder='Title'
					onChange={(evt) => {
						setPostTitle(evt.target.value)
					}}
				/> */}
				<textarea 
					className='app-new-post-message-input'
					value={postMessage}
					placeholder='What do you want to say'
					disabled={makingPost}
					onChange={(evt) => {
						setPostMessage(evt.target.value ? evt.target.value.substring(0, 1200) : evt.target.value)
					}}
				/>
				<div
					className='app-new-post-bottom-button-wrap'
				>
					<img
						className='app-new-post-bottom-button'
						src='/imgs/icons/posts/icon-new-post-button-video.svg'
						alt='Video button'
					/>
				</div>
			</div>
		</>
	)
}

export default AppPost
